/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-23 11:24:19
 * @modify date 2021-08-23 11:24:19
 * @desc [枚举]
 */

/**
 * @export 通知类型
 * @enum 
 */
export enum EnumMicroNoticeType {
    RouteChange = 'RouteChange'
}
